import { getSettingValueWithoutAssignment } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/getSetting";
import { ISignUpRequest } from "@faire/web-api--source/indigofair/data/ISignUpRequest";
import { RETAILER_PRIORITIZED_BUSINESS_PLATFORMS_ON_SIGN_UP } from "@faire/web-api--source/indigofair/settings/RETAILER_PRIORITIZED_BUSINESS_PLATFORMS_ON_SIGN_UP";

export const getSettingSignUpBusinessTypes =
  (): (keyof typeof ISignUpRequest.BusinessPlatform)[] => {
    return getSettingValueWithoutAssignment(
      RETAILER_PRIORITIZED_BUSINESS_PLATFORMS_ON_SIGN_UP,
      []
    );
  };
